import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

export const IconColumnView = ({ sx, ...props }: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: "none", ...sx }}>
        <svg width="20" height="19.249" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3269_2790)">
                <path
                    d="M3.50605 5.0091H20.4954C21.326 5.0091 22 4.33506 22 3.50455C22 2.67404 21.326 2 20.4954 2H3.50455C2.67404 2 2 2.67404 2 3.50455C2 4.33506 2.67404 5.0091 3.50455 5.0091H3.50605Z"
                    fill="currentColor"
                />
                <path
                    d="M3.50605 21.2493H20.4954C21.326 21.2493 22 20.5753 22 19.7448C22 18.9143 21.326 18.2402 20.4954 18.2402H3.50455C2.67404 18.2402 2 18.9143 2 19.7448C2 20.5753 2.67404 21.2493 3.50455 21.2493H3.50605Z"
                    fill="currentColor"
                />
                <path
                    d="M3.50605 13.1292H20.4954C21.326 13.1292 22 12.4552 22 11.6247C22 10.7942 21.326 10.1201 20.4954 10.1201H3.50455C2.67404 10.1201 2 10.7942 2 11.6247C2 12.4552 2.67404 13.1292 3.50455 13.1292H3.50605Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_3269_2790">
                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
);
